
import { createEdit, DELETE } from '@/helpers/enums/table-actions'
import { PERMISSIONS_PERMISSIONS_ROUTES as ROUTES } from './utils'


const getEditRoute = (data) => ({
  name: ROUTES.EDIT,
  params: { id: data.id },
})

export const TABLE_ACTIONS = Object.freeze([
  createEdit(getEditRoute),
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'name',
    sortable: false,
    getRoute: (data) => ({
      name: ROUTES.VIEW,
      params: { id: data.id },
    }),
  },
  {
    text: 'Код',
    value: 'code',
    sortable: false,
  },
])
